<template>
  <div id="mark-modal-category-select">
    <template v-if="isViewComponent()">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Выберите категорию</h3>
            </div>
            <div class="modal-body">
              <div class="item mb-5" v-for="item in getItems()" :key="row.getShopId(item)">
                <div class="row">
                  <div class="col-3">
                    <span class="h3">{{ row.getShopName(item) }}</span>
                    <div class="d-block text-secondary text-truncate mt-n1">{{ row.getShopHost(item) }}</div>
                  </div>
                  <div class="col-9">
                    <GroupSelect :payload="{
                      post_id: getPayloadPostId(),
                      shop_id: row.getUniqShopId(item),
                      category_id: getCategoryId()
                    }" @changeVal="changeGroupSelect"/>
                  </div>
                </div>
                <template v-if="isPayloadShopTypeMore()">
                  <div class="text-reset d-block text-truncate mt-2" v-html="row.getCompositeText(item)"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-body">
        <div class="container-xl">
          <div class="row">
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, reactive, ref, watch} from "vue"
import Api from "./services/Api"

import Helper from "@/services/Helper"
import ShopImage from "@/modules/shops/services/ShopImage"

import GroupSelect from "./components/group_select/Index"

export default defineComponent({
  name: "Category",
  components: {
    GroupSelect,
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit, expose}) {
    let viewComponent = ref(false)
    let items = ref({})

    const payload = reactive({
      post_id: null,
      shop_items: {},
      shop_type: null,
      category_id: null,
    })

    let row = {
      getUniqShopId: (item) => {
        let isCompositePost = item["composite_id"] !== null

        if (isCompositePost) {
          return item["composite_id"]
        } else {
          return item["shop_id"]
        }
      },
      getShopId: (item) => {
        return item["shop_id"]
      },
      getShopName: (item) => {
        return item["shop_name"]
      },
      getShopImage: (item, w) => {
        if (item["shop_image_host"] !== null && item["shop_image_name"] !== null) {
          return getImage(item["shop_image_host"], item["shop_image_name"], w)
        } else {
          return getImage(null, null, w)
        }
      },
      getShopHost: (item) => {
        return item["shop_host"]
      },
      getCompositeId: (item) => {
        return item["composite_id"]
      },
      getCompositeText: (item) => {
        return item["composite_text"]
      },
    }

    onMounted(async () => {
      updatePayload(props.payload)

      let categoryId = await fetchCategoryId(getPayloadPostId())
      setCategoryId(categoryId)

      Api.bindCategory(getPayloadPostId(), getPayloadShopItems()).then((resp) => {
        setItems(resp["items"])
        enableViewComponent()
      })
    })

    async function fetchCategoryId(postId) {
      let resp = await Api.getPost(postId)
      let categoryId = resp.item?.category_id

      if (categoryId === undefined) {
        throw new Error("Ошибка при получении категории")
      }

      return categoryId
    }

    function getCategoryId() {
      return payload.category_id
    }

    onUnmounted(() => {
      disableViewComponent()
    })

    watch(() => props.payload, (newValues) => {
      updatePayload(newValues)
    })

    function getImage(host, name, w = null, h = null) {
      return ShopImage.handle(host, name, w, h)
    }

    function updatePayload(query) {
      payload.post_id = query.post_id
      payload.shop_items = query.shop_items
      payload.shop_type = query.shop_type
    }

    function setItems(val) {
      items.value = val
    }

    function setCategoryId(categoryId) {
      payload.category_id = categoryId
    }

    function hasItems() {
      return !Helper.isEmptyObject(getItems())
    }

    function getItems() {
      return items.value
    }

    function getPayloadPostId() {
      return payload.post_id
    }

    function getPayloadShopItems() {
      return payload.shop_items
    }

    function isPayloadShopTypeMore() {
      return payload.shop_type === "more"
    }

    async function startRequest(postId, items) {
      return Api.erid(postId, items)
    }

    expose({ startRequest })

    function enableViewComponent() {
      viewComponent.value = true
    }

    function disableViewComponent() {
      viewComponent.value = false
    }

    function isViewComponent() {
      return viewComponent.value === true
    }

    function changeGroupSelect(val) {
      emit("changeVal", {
        "shop_id": val["shop_id"],
        "category_id": val["category_id"],
      })
    }

    return {
      getPayloadPostId,
      getPayloadShopItems,
      isViewComponent,
      hasItems,
      getItems,
      row,
      isPayloadShopTypeMore,
      changeGroupSelect,
      getCategoryId,
    }
  }
})
</script>
